import React, { useEffect, useRef } from 'react';

interface SafeHTMLProps {
  content: string;
}

export function SafeHTML({ content }: SafeHTMLProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Fonction pour charger les scripts
    const loadScripts = () => {
      const container = containerRef.current;
      if (!container) return;

      // Trouver tous les scripts dans le contenu HTML
      const scriptElements = container.getElementsByTagName('script');
      
      // Convertir la HTMLCollection en Array pour pouvoir itérer
      Array.from(scriptElements).forEach(scriptElement => {
        const newScript = document.createElement('script');
        
        // Copier tous les attributs
        Array.from(scriptElement.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });
        
        // Copier le contenu inline si présent
        if (scriptElement.innerHTML) {
          newScript.innerHTML = scriptElement.innerHTML;
        }
        
        // Remplacer l'ancien script par le nouveau
        scriptElement.parentNode?.replaceChild(newScript, scriptElement);
      });
    };

    // Injecter le contenu HTML
    containerRef.current.innerHTML = content;
    
    // Charger les scripts
    loadScripts();

    // Cleanup
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [content]);

  return <div ref={containerRef} className="safe-html-container" />;
}